"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      color: theme.palette.common.black,
      paddingRight: theme.spacing(1),
      '&:not(:first-child)': {
        paddingLeft: theme.spacing(1)
      },
      '&:not(:last-child)': {
        borderRight: '1px solid rgba(0,0,0,.3)'
      }
    }
  };
}, {
  name: 'SxWebMainNavigationItemPopoverNestItem'
});

function MainNavigationItemPopoverNestItem(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      href = _ref.href,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "href"]);
  var classes = useStyles({
    classes: pClasses
  });
  return _react.default.createElement(_Link.default, (0, _extends2.default)({}, rest, {
    to: href,
    className: (0, _clsx.default)(classes.root, className)
  }), children);
}

MainNavigationItemPopoverNestItem.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  href: _propTypes.default.string
};
MainNavigationItemPopoverNestItem.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  href: undefined
};
var _default = MainNavigationItemPopoverNestItem;
exports.default = _default;